import script from "./TemplateColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateColumn.vue?vue&type=script&setup=true&lang=js"

import "./TemplateColumn.vue?vue&type=style&index=0&id=cca0563c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cca0563c"]])

export default __exports__